module.exports = __webpack_public_path__ + "static/media/blue_img_c.a6ad8101.png";